module.exports = __webpack_public_path__ + "static/img/xinyuan3.54e401b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/xinyuan3.png
// module id = d/J3
// module chunks = 1